import { SupportedChainId } from '@orionprotocol/sdk';

export function checkNetworkIsEqualToWalletNetwork(
  networkChainId: SupportedChainId | undefined,
  walletChainId: number | string | undefined,
): boolean {
  if (walletChainId === undefined || networkChainId === undefined) return false;
  return walletChainId.toString(10) === networkChainId.toString();
}
